var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"flex flex-center"},[_c('img',{attrs:{"alt":"Quasar logo","src":require("../assets/logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }